// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1JGgU","large":"styles_large__38wai"};